"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectPicker = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var WorkbookTemplateWidgetsStyles_1 = require("../../styles/WorkbookTemplateWidgetsStyles");
var VizportalApi_1 = require("../../vizportalapi/VizportalApi");
/* tslint:disable:import-blacklist */
var nested_project_explorer_1 = require("@tableau/nested-project-explorer");
var ProjectPicker = /** @class */ (function (_super) {
    __extends(ProjectPicker, _super);
    function ProjectPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { projects: null, selectedProjectId: '' };
        _this.projectSelected = _this.projectSelected.bind(_this);
        return _this;
    }
    ProjectPicker.prototype.projectSelected = function (project) {
        var projectId = project !== null ? project.id : '';
        this.props.onProjectSelected(projectId);
    };
    // Only set the initial project selected after we've collected all data
    // and have rendereded the project explorer
    ProjectPicker.prototype.onInitialProjectSelected = function () {
        if (this.haveDataToRenderProjectExplorer()) {
            this.props.onProjectSelected(this.state.selectedProjectId);
        }
    };
    ProjectPicker.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var projects, e_1, destinationProjects;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        projects = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, VizportalApi_1.VizportalApiService.GetDestinationProjects()];
                    case 2:
                        projects = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        destinationProjects = projects.map(function (project) { return ({
                            id: project.id,
                            name: project.name,
                            parentId: project.parentProjectId,
                            childItemCount: project.childProjectCount,
                            topLevelItem: project.topLevelProject,
                            controlledPermissionsEnabled: project.controlledPermissionsEnabled,
                            status: project.status,
                            itemType: nested_project_explorer_1.DestinationItemType.project,
                        }); });
                        this.setState({ projects: destinationProjects });
                        this.onInitialProjectSelected();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProjectPicker.prototype.haveDataToRenderProjectExplorer = function () {
        return this.state.projects !== null;
    };
    ProjectPicker.prototype.render = function () {
        if (this.haveDataToRenderProjectExplorer()) {
            return (React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsProjectPickerStyles.ProjectPickerContainerDiv },
                React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsProjectPickerStyles.ProjectPickerDiv },
                    React.createElement(nested_project_explorer_1.NestedProjectExplorer, { topLevelDestinationStatus: 'structurally_invalid', projects: nested_project_explorer_1.NestedItemsTreeHelper.convertItemListToTrees(this.state.projects), onSelectedProjectChanged: this.projectSelected }))));
        }
        else {
            return (React.createElement("div", { className: "tab-fill-centered " + WorkbookTemplateWidgetsStyles_1.WorkbookTemplateWidgetsProjectPickerStyles.ProjectPickerContainerDiv },
                React.createElement(widgets_1.ActivitySpinnerWidget, { testId: 'waiting' })));
        }
    };
    return ProjectPicker;
}(React.PureComponent));
exports.ProjectPicker = ProjectPicker;
//# sourceMappingURL=ProjectPicker.js.map